import { postRequest } from "../config/AxiosConfig";
import API_URLS from "../config/BackendConfig";
import { getAuthToken } from "../utils/tokenUtils";

export const getTopUsedService = async (payload) => {
    try {
      
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "services/top-used-services",
            headers: { 'Authorization': `Bearer ${token}` },
            data: payload
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getEndpointOrServiceName = async (payload) => {
    try {
      
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "services/service-lookup",
            headers: { 'Authorization': `Bearer ${token}` },
            data: payload
        });
        return response;
    } catch (error) {
        return error;
    }
}